// extracted by mini-css-extract-plugin
export default {"wrapper":"DD-z","viewport":"ED-z","container":"FD-z","slide":"GD-z"};